module.exports = __webpack_public_path__ + "media/images/material-check-a41bc6261523502e471c90492cdac68b.svg";